module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/winnerMale-263a967b841576129fddf00fcbb79c22.png";